module.exports = __webpack_public_path__ + "static/media/tracking_img.1ad0c4f6.svg";